import React, { createContext, useContext, useEffect, useState } from "react";
import { authApi, tokenStore } from "../lib/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let mounted = true;
    const t = tokenStore.get();
    if (!t) {
      setChecked(true);
      return;
    }
    authApi
      .me()
      .then((data) => {
        if (mounted) setAdmin(data);
      })
      .catch(() => {
        tokenStore.clear();
      })
      .finally(() => {
        if (mounted) setChecked(true);
      });
    return () => {
      mounted = false;
    };
  }, []);

  const login = async (email, password) => {
    const data = await authApi.login(email, password);
    tokenStore.set(data.access_token);
    setAdmin(data.admin);
    return data.admin;
  };

  const logout = () => {
    tokenStore.clear();
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, checked, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
